import React, { forwardRef } from 'react'
import { Button, Space } from 'antd'
import { useIntl } from 'react-intl'
import { CloseOutlined, FilterOutlined } from '@ant-design/icons'

function Filter({
  icon = <FilterOutlined />,
  title = 'button.filter',
  onClick = () => {},
  id = 'btn-filter',
  showClearBtn = false,
  onClear = () => {},
  innerRef,
  ...props
}) {
  const { formatMessage } = useIntl()
  const newTitle = title === 'button.filter' ? formatMessage({ id: title }) : title
  return (
    <Space ref={innerRef}>
      <Button icon={icon} onClick={onClick} id={id} {...props} title={newTitle}>
        {newTitle}
      </Button>
      {!props.loading && showClearBtn && (
        <Button onClick={onClear} icon={<CloseOutlined />} danger>
          {formatMessage({ id: 'button.clear_filter' })}
        </Button>
      )}
    </Space>
  )
}

const FilterComponent = forwardRef((props, ref) => <Filter {...props} innerRef={ref} />)
FilterComponent.displayName = 'Filter'

export default FilterComponent
